import { useState, type FormEvent } from "react";
import { useLocation } from "react-router";
import { Photo } from "../../components/Photo.tsx";
import { useSession } from "../../app/session.tsx";
import { packAgeLabel, readPackMeta } from "../../lib/offline.ts";

export function LockScreen() {
  const { login, openDownloadedTrip } = useSession();
  const location = useLocation();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const pack = readPackMeta();
  const resumePath = location.pathname !== "/" ? location.pathname : "";

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(password);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not unlock.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="page" style={{ paddingTop: 28 }}>
      <div className="hero">
        <Photo assetId="lock" alt="Warm Thailand landscape" priority height={280} />
        <div className="hero-copy">
          <p className="kicker">Private companion</p>
          <h1 className="serif" style={{ margin: "8px 0 0", fontSize: "2rem" }}>
            Thailand, together
          </h1>
        </div>
      </div>
      <p className="muted" style={{ marginTop: 20 }}>
        For our family. Enter the shared password to open the trip.
        {resumePath ? " After you sign in, this phone will open the page you were sent to." : ""}
      </p>
      <form onSubmit={(e) => void onSubmit(e)} style={{ marginTop: 16 }}>
        <label className="field">
          Password
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {error ? <p className="banner crit">{error}</p> : null}
        <button className="btn" type="submit" disabled={busy} style={{ width: "100%" }}>
          {busy ? "Unlocking…" : "Unlock"}
        </button>
      </form>
      {pack.ready ? (
        <section className="card" style={{ marginTop: 20 }}>
          <h2 className="serif">This phone already has the trip</h2>
          <p className="muted">{packAgeLabel(pack)}. Opens as family read-only until you sign in again.</p>
          <button
            className="btn-secondary"
            type="button"
            onClick={() => {
              void openDownloadedTrip().then((ok) => {
                if (!ok) setError("The downloaded pack is missing or incomplete.");
              });
            }}
          >
            Open downloaded trip
          </button>
        </section>
      ) : null}
    </main>
  );
}
